import React from "react"
import {FieldViewSize} from "../../../const";
import EditableInput from "./inline-editable/input-component";
import {isBulkSelection} from "../../../../gd/right-click-menu";
import GoogleApi from "../../../../gd/api/google-api";
import Addresses from "../../../../model2/address/addresses";
import {FieldFormElementViewProps} from "../../../render/form-elemnent-view";
import Address from "../../../../model2/address/address";
import Location from "../../../../model2/address/location";

const debug = false
// const debug = "FieldAddress_FormElementView"

type State = {
    initialPropsValue?  : any
    currentOption       : Address | null
    showPopover         : boolean
    inputValue          : string
    options             : Option[]
}

export default class FieldAddress_FormElementView extends React.Component<FieldFormElementViewProps, State> {

    constructor(props: FieldFormElementViewProps) {
        super(props);

        const value = this.props.field.getViewValue(this.props.model)

        this.state = {
            currentOption       : value,
            showPopover         : false,
            inputValue          : value?.description,
            options             : []
        }
    }

    hidePopover = () => {
        if (this.state.showPopover) {
            this.setState({showPopover: false})
        }
    }

    onImmediateChange = async (value: string) => {

        this.setState({inputValue: value});

        if(value?.length > 0){
            this.setState({showPopover: true})
        }
        else{
            this.setState({showPopover: false})
        }

        try{
            const response: any = await GoogleApi.searchPlaces(this.state.inputValue)

            debug && console.log(debug, "Response?", response)

            const addressCollection = Addresses.initFromJson(response?.suggestions)

            this.setState({options: addressCollection.toOptions()})
        }
        catch(e){
            console.error(e)
        }
    };

    onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()

        this.onChange(null)
    }

    onChange = (newValue: Address | null) => {

        this.setState({currentOption: newValue})

        this.props.onChange && this.props.onChange(newValue)

        this.setState({showPopover: false, options: []})
    }

    onOptionClick = async (option: Option)=> {

        try {
            const response = await GoogleApi.getPlaceLocation(option.value.placeId)

            if(option.value.placeId.length > 0){

                option.value.isValid = true
                option.value.location = new Location(response.location)

                this.onChange(option.value)
            }
        } catch (e){
            console.error(e)
        }
    }

    getClasses = ()=>{

        return  Classes("ui5-field-form-editable", this.props.className, {
            "ui5-txt-default": this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
    }

    renderValue = (displayValue: string)=>{

        return (
            <div className="flex-row-left-center txt-truncate">
                {displayValue && <div className="i5-location ui5-ico-16 m-r-5"></div>}
                <div className="txt-truncate">
                    {displayValue}
                </div>
            </div>
        )
    }

    render() {

        const field   = this.props.field
        this.props.field.options = this.state.options
        const disabled  = _.get(this.props, 'disabled', false)

        return (
            <>
                <EditableInput className         = "ui5-txt-default ui5-field-form-editable w-100-percent h-36" // p-l-10 p-r-10
                               inputClassName    = "ui5-txt-default"
                               value             = {field.getDisplayValue(this.state.currentOption)}
                               disabled          = {disabled}
                               focusOnMount      = {true}
                               placeholder       = {this.props.field.placeholder}
                               onImmediateChange = {this.onImmediateChange}/>
                {this.state.showPopover  && (
                    <field.components.PopoverMenu parent = {this}
                                                  field  = {this.props.field}
                                                  model  = {this.props.model}/>
                )}
            </>
        )
    }
}
